import { Button } from '@user-portal/wikr-components';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import gradient from './img/gradient.svg?raw';

export const SupportButton = styled(Button)`
    margin-top: 16px;
`;

export const PlanLink = styled(NavLink)`
    margin-top: 32px;
`;

export const Container = styled.div<{ $isOpen: boolean }>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    max-width: 600px;
    padding: ${({ $isOpen }) => ($isOpen ? '42px 0 42px' : '42px 0 0')};
    margin: 0 auto;
    text-align: center;
    background-image: url('data:image/svg+xml,${encodeURIComponent(gradient)}');
    background-repeat: no-repeat;
    background-position-x: right;
    background-size: contain;
    white-space: pre-line;
`;

export const Wrapper = styled.div`
    padding: 0 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;
